<template>
	<div
		:class="context.classes.element"
		:data-type="context.type"
	>
		<FormulateSlot
			name="prefix"
			:context="context"
		>
			<component
				:is="context.slotComponents.prefix"
				v-if="context.slotComponents.prefix"
				:context="context"
			/>
		</FormulateSlot>
		<input
			v-model="context.model"
			type="date"
			v-bind="attributes"
			@blur="context.blurHandler"
			v-on="$listeners"
			:max="max"
		>
		<FormulateSlot
			name="suffix"
			:context="context"
		>
			<component
				:is="context.slotComponents.suffix"
				v-if="context.slotComponents.suffix"
				:context="context"
			/>
		</FormulateSlot>
	</div>
</template>
<script>

import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: "Birthday",
    computed: {
        max() {
            return new Date().toISOString().split("T")[0]
        }
    },
    mixins: [FormulateInputMixin]
}
</script>

<style scoped>

</style>